import React from 'react';

import { StyleSheet } from 'react-native';
import type { ViewStyle } from 'react-native';

import { Box, BoxProps } from 'components/ui';
import { layout, primitive, shadows, spacing } from 'styles/constants';

export const Container = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, {
    ...props,
    style: [styles.container, style],
  });

export const MapContainer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, {
    ...props,
    style: [styles.mapContainer, style],
  });

export const DeliveryDetailsContainer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, {
    ...props,
    style: [styles.deliveryDetailsContainer, style],
  });

const styles = StyleSheet.create({
  container: {
    ...shadows.$1,
    borderRadius: primitive.$borderRadius,
    overflow: 'hidden',
  } as ViewStyle,
  deliveryDetailsContainer: {
    backgroundColor: primitive.$white,
    width: layout.full,
  },
  mapContainer: {
    height: spacing.$48,
    width: layout.full,
  },
});
